<script lang="ts">
    
    import { Icon } from "sveltestrap";

    export let isDeployed: boolean;

    const transitionDuration = '0.3s';

    let style = '';

    $: updateComponent(isDeployed);

    function updateComponent(isDeployed: boolean): void {
        if (!isDeployed) {
            style = `display: inline-block; transition: transform ${transitionDuration};`;
            return;
        }
        style = `display: inline-block; transition: transform ${transitionDuration}; transform: rotate(90deg);`;
    }

</script>

<Icon name="chevron-right" {style} />
